import { render, staticRenderFns } from "./ResultRow.vue?vue&type=template&id=3488e1a6&scoped=true"
import script from "./ResultRow.vue?vue&type=script&lang=js"
export * from "./ResultRow.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/badge.css?vue&type=style&index=0&id=3488e1a6&prod&scoped=true&lang=css&external"
import style1 from "./ResultRow.vue?vue&type=style&index=1&id=3488e1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488e1a6",
  null
  
)

export default component.exports